
export class UpdateEmailRequestDto {
  newEmail: string;
  confirmPassword: string;
}
